export const CALENDLY_URL = 'https://calendly.com/fodil-asma-databi-solutions/30min';
